export const frontmatter = {
    "draft": false,
    "title": "Administration",
    "sidebar_group": "reference",
    "sidebar_label": "Administration",
    "sidebar_order": 1
}

export const toc = []